export const AUDIT_STATUSES = {
  REQ: "REQ",
  SENT: "SENT",
  FATAL: "FATAL",
  NO_AGENT: "NO-AGENT",
  ERR_NO_AGT: "ERR-NO-AGT",
  ERR_FILEEXT: "ERR-FILEEXT",
  ERR_SHORT: "ERR-SHORT",
  ERR_INVALID: "ERR-INVALID",
  ERR_MAIL: "ERR-MAIL"
}

export const TASK_STATUSES = {
  IDLE: "IDLE",
  RUNNING: "RUNNING",
  DEAD: "DEAD",
  ERROR: "ERROR"
}